import INTERNAL from "./client"

function createOktaUser(data, preview = false) {
    return post(`/okta/createUser`, data, {}, preview)
}

function getOktaUser(oktaUserId, preview = false) {
    return get(`/okta/getUser/${oktaUserId}`, {}, preview)
}

function getUsersGroups(oktaUserId) {
    return get(`/okta/groups/${oktaUserId}`)
}

function addUserToOktaGroup({ oktaUserId, groupId }) {
    return get(`/okta/groups/${oktaUserId}/${groupId}`)
}

function get(path, config = {}, preview = false) {
    setPreviewHeader(preview)
    return INTERNAL.get(path, config)
        .then(response => {
            return response.data
        })
        .catch(error => {
            // console.log(error.message)
            return {
                error: error.message,
            }
        })
}

function post(path, data, config = {}, preview = false) {
    setPreviewHeader(preview)
    return INTERNAL.post(path, data, config)
        .then(response => {
            return response.data
        })
        .catch(error => {
            // console.log(error.message)
            return {
                error: error.message,
            }
        })
}

function setPreviewHeader(preview) {
    INTERNAL.defaults.headers.common["preview"] = preview ? "true" : "false"
}

export { getUsersGroups, getOktaUser, createOktaUser, addUserToOktaGroup }
